import StartInquiry from "../components/pages/Inquiry/StartInquiry";

const startInquiry = [
    {
        path: '/start-onderzoek',
        component: StartInquiry,
        name: 'start-inquiry'
    },
]

export default startInquiry
